// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KRu_w","col":"styles_col__ymYHV"};